import React, { useState } from 'react';

const ContactUs = () => {
  const [formData, setFormData] = useState({ name: '', email: '', mobile: '', services: [], message: '' });
  
  const servicesList = [
    'Network Installation & Troubleshooting',
    'POS Installation & Troubleshooting',
    'Wireless Site Surveys',
    'Wireless Installation & Troubleshooting',
    'Analog Phone System Services',
    'VOIP Phone System Services',
    'Circuit Extensions',
    'Low Voltage Structured Cabling',
    'Fiber Optic Cabling',
    'CCTV',
    'Alarm Systems',
    'Traffic System Installation',
    'Digital Signage',
    'Access Control Systems',
    'Secure Shredding'
  ];

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      services: checked ? [...prevState.services, value] : prevState.services.filter(s => s !== value)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const emailBody = `
      A new inquiry has been submitted from the website with the following details:

      Name: ${formData.name}
      Email: ${formData.email}
      Mobile Number: ${formData.mobile || 'Not provided'}

      Services of Interest:
      ${formData.services.length > 0 ? formData.services.map(s => `- ${s}`).join('\n      ') : 'None selected'}

      Message:
      ${formData.message}
    `.trim();

    const subject = "Inquiry";
    const mailtoLink = `mailto:info@bitdeploy.ca?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;

    // --- THIS LINE HAS BEEN UPDATED ---
    // Open the user's default email client in a new tab/window
    window.open(mailtoLink, '_blank');

    setFormData({ name: '', email: '', mobile: '', services: [], message: '' });
  };

  return (
    <section id="contact" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
            <h3 className="text-base uppercase font-semibold text-blue-600">Contact Us</h3>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 my-3">Ready to Elevate Your IT Infrastructure?</h2>
        </div>
        <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-lg shadow-xl">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input type="text" name="name" id="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"/>
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input type="email" name="email" id="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"/>
              </div>
            </div>
            <div>
              <label htmlFor="mobile" className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
              <input type="tel" name="mobile" id="mobile" value={formData.mobile} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"/>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Service of Interest</label>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {servicesList.map(service => (
                  <label key={service} className="flex items-center space-x-2">
                    <input type="checkbox" name="services" value={service} checked={formData.services.includes(service)} onChange={handleCheckboxChange} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"/>
                    <span className="text-sm text-gray-700">{service}</span>
                  </label>
                ))}
              </div>
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Message</label>
              <textarea name="message" id="message" rows="5" value={formData.message} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"></textarea>
            </div>
            <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition duration-300">Submit Inquiry</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;

